import React from 'react';
import PackageCard from './PackageCard';

export default function PackagesList({ packages, onFocusStop, showCompany }) {
  return (
    <div data-testid="packages-list">
      {packages.map((pkg) => (
        <PackageCard key={pkg.id} pkg={pkg} onFocusStop={onFocusStop} showCompany={showCompany} />
      ))}
    </div>
  );
}
